import CheckTypeCForm from "./CheckTypeCForm.jsx";

export default CheckTypeCForm;